import "../../css/modal/PaymentHoldingModal.css";
import { useState } from "react";
import { getDateString, calculateHoldingDays } from "../../utils/Utils";
import proxy from "../../utils/Proxy";

let PaymentHoldingModal = (props) => {
    let [holdingData, setHoldingData] = useState({
        start: "",
        end: ""
    });
    let [isSubmitting, setIsSubmitting] = useState(false);

    let handleInputChange = (field, value) => {
        setHoldingData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    let validateHoldingDates = () => {
        if (!holdingData.start || !holdingData.end) {
            window.alert("시작일과 종료일을 모두 입력해주세요.");
            return false;
        }

        const currentDate = new Date();
        const startDate = new Date(holdingData.start);
        const endDate = new Date(holdingData.end);
        const paymentStartDate = new Date(props.payment.start);
        const paymentEndDate = new Date(props.payment.end);

        // 종료일이 시작일보다 늦어야 함
        if (startDate >= endDate) {
            window.alert("종료일은 시작일보다 늦어야 합니다.");
            return false;
        }

        // 홀딩 시작일은 현재 날짜 이후여야 함
        if (startDate <= currentDate) {
            window.alert("홀딩 시작일은 현재 날짜보다 이후여야 합니다.");
            return false;
        }

        // 홀딩 시작일은 payment의 start 이후여야 함
        if (startDate <= paymentStartDate) {
            window.alert("홀딩 시작일은 수강 시작일보다 이후여야 합니다.");
            return false;
        }

        // 홀딩 종료일은 payment의 end 이전이어야 함
        if (endDate > paymentEndDate) {
            window.alert("홀딩 종료일은 수강 종료일보다 이전이어야 합니다.");
            return false;
        }

        // 홀딩 기간이 max_holding_amount보다 작아야 함
        const holdingDays = calculateHoldingDays(holdingData.start, holdingData.end);
        const maxHoldingDays = props.payment.max_holding_amount || 0;

        if (holdingDays > maxHoldingDays) {
            window.alert(`홀딩 기간은 최대 ${maxHoldingDays}일까지 신청 가능합니다. (현재 ${holdingDays}일)`);
            return false;
        }

        return true;
    };

    let handleSubmit = async () => {
        if (!validateHoldingDates()) {
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await proxy.post("/api/holdings", {
                paymentid: props.payment.paymentid,
                start: holdingData.start,
                end: holdingData.end
            });

            if (response.data.result) {
                window.alert("홀딩 요청이 완료되었습니다.");
                props.onClose();
                props.onSuccess();
            } else {
                window.alert("홀딩 요청에 실패했습니다.");
            }
        } catch (error) {
            console.error("홀딩 요청 실패:", error);
            window.alert("홀딩 요청 중 오류가 발생했습니다. 대기 중인 홀딩이 있는 경우 취소 후 다시 시도해주세요.");
        } finally {
            setIsSubmitting(false);
            props.setNeedUpdate(true);
        }
    };

    let handleClose = () => {
        if (!isSubmitting) {
            props.onClose();
        }
    };

    // 최소 시작일 신청 (현재 날짜 + 1일)
    let getMinStartDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    };

    // 최대 종료일 신청 (payment.end)
    let getMaxEndDate = () => {
        return props.payment.end;
    };
    return (
        <div className="payment-holding-modal-overlay" onClick={handleClose}>
            <div className="payment-holding-modal" onClick={(e) => e.stopPropagation()}>
                <div className="payment-holding-modal-header">
                    <h3>홀딩 신청</h3>
                    <button 
                        className="payment-holding-modal-close" 
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>
                
                <div className="payment-holding-modal-content">
                    <div className="payment-holding-info">
                        <div className="payment-holding-info-row">
                            <span className="payment-holding-label">결제일:</span>
                            <span className="payment-holding-value">
                                {getDateString(new Date(props.payment.payment_date))}
                            </span>
                        </div>
                        <div className="payment-holding-info-row">
                            <span className="payment-holding-label">결제금액:</span>
                            <span className="payment-holding-value">
                                {props.payment.payment_amount.toLocaleString()}원
                            </span>
                        </div>
                        <div className="payment-holding-info-row">
                            <span className="payment-holding-label">수강기간:</span>
                            <span className="payment-holding-value">
                                {props.payment.startdate_non_set ? "시작일 미정" : 
                                 `${getDateString(new Date(props.payment.start))} ~ ${getDateString(new Date(props.payment.end))}`}
                            </span>
                        </div>
                        <div className="payment-holding-info-row">
                            <span className="payment-holding-label">최대 홀딩 가능일:</span>
                            <span className="payment-holding-value">
                                {props.payment.max_holding_amount || 0}일
                            </span>
                        </div>
                        <div className="payment-holding-info-row">
                            <span className="payment-holding-label">사용한 홀딩일:</span>
                            <span className="payment-holding-value">
                                {props.payment.used_holding_amount || 0}일
                            </span>
                        </div>
                    </div>

                    <div className="payment-holding-form">
                        <div className="payment-holding-form-row">
                            <label className="payment-holding-form-label">시작일</label>
                            <input
                                type="date"
                                className="payment-holding-form-input"
                                value={holdingData.start}
                                onChange={(e) => handleInputChange('start', e.target.value)}
                                min={getMinStartDate()}
                                max={getMaxEndDate()}
                                disabled={isSubmitting}
                            />
                        </div>
                        <div className="payment-holding-form-row">
                            <label className="payment-holding-form-label">종료일</label>
                            <input
                                type="date"
                                className="payment-holding-form-input"
                                value={holdingData.end}
                                onChange={(e) => handleInputChange('end', e.target.value)}
                                min={holdingData.start || getMinStartDate()}
                                max={getMaxEndDate()}
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                </div>

                <div className="payment-holding-modal-footer">
                    <button 
                        className="payment-holding-modal-cancel"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        취소
                    </button>
                    <button 
                        className="payment-holding-modal-submit"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "신청 중..." : "신청"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentHoldingModal; 